var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#wave-horizontal';
                    var viewUrl = 'sprite.svg#view-wave-horizontal';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 1384 72',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };